/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import axios, { AxiosInstance, AxiosResponse } from 'axios'

import { ReservationRequestRepository } from './domain'

import { ServiceError } from '../../foundation'
import {
  ChangeReservationTimeCommand,
  MakeReservationJpCommand,
  MakeReservationJpSuccessResponse,
  MakeReservationKrCommand,
  TryReservationCommand,
} from '../../contracts/reservation'
import { OrderProgress, OrderProgressState } from '../../contracts/appointment/orderProgress'

export class UserApiReservationRequestRepository implements ReservationRequestRepository {
  constructor(private axios: AxiosInstance) {}

  private getOrderProgressUntilComplete = async (orderProgressId: string, count = 0) => {
    if (count > 10) {
      throw new Error('fetching order progress reached limit, but failed to resolve')
    }

    return await this.axios.get(`/appointments/order-saga/${orderProgressId}`).then((response: AxiosResponse) => {
      const state = response.data.state
      const isFailure = response.data.isFailure
      if (state === OrderProgressState.COMPLETED) {
        return response.data
      } else if (isFailure) {
        return response.data
      }

      setTimeout(() => this.getOrderProgressUntilComplete(orderProgressId, count + 1), 1000)
    })
  }

  async makeReservationKr(command: MakeReservationKrCommand): Promise<OrderProgress> {
    try {
      const { data: reservationData } = await this.axios.post('/appointments/order-saga/make-reservation', command)

      return await this.getOrderProgressUntilComplete(reservationData.progressId)
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.data) {
        throw error.response as AxiosResponse<ServiceError>
      }

      throw error
    }
  }

  async makeReservationJp(command: MakeReservationJpCommand): Promise<MakeReservationJpSuccessResponse> {
    const { data } = await this.axios.request<MakeReservationJpSuccessResponse>({
      url: '/v1/reservations/commands/make-a-reservation/execute',
      method: 'post',
      data: command,
    })

    return data
  }

  async tryReservation(command: TryReservationCommand): Promise<{ reservationId: number; progressId: string }> {
    try {
      const { data } = await this.axios.request<{ reservationId: number; progressId: string }>({
        url: '/appointments/order-saga/try-reservation',
        method: 'post',
        data: command,
      })

      return data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.data) {
        throw error.response as AxiosResponse<ServiceError>
      }
      throw error
    }
  }

  async changeReservationTime(command: ChangeReservationTimeCommand) {
    await this.axios.request({
      url: '/v1/reservations/commands/change-reservation-time/execute',
      method: 'post',
      data: command,
    })
  }
}
